import http from "@/services/http";
import { defineStore } from "pinia";
import {ref,computed} from 'vue';
import router from '@/router/index.js';

export const useAuth = defineStore('auth', () => {
    const token = ref(localStorage.getItem('token'));
    const userJson = ref(localStorage.getItem('user'));
    const tenantJson = ref(localStorage.getItem('tenant'));

    const user = computed(() => {
        if (!userJson.value) return null;
        try {
            return typeof userJson.value === 'string' 
                ? JSON.parse(userJson.value) 
                : userJson.value;
        } catch (e) {
            console.error('Erro ao parsear usuário:', e);
            return null;
        }
    });

    const tenant = computed(() => {
        if (!tenantJson.value) return null;
        try {
            return typeof tenantJson.value === 'string' 
                ? JSON.parse(tenantJson.value) 
                : tenantJson.value;
        } catch (e) {
            console.error('Erro ao parsear tenant:', e);
            return null;
        }
    });

    const lastVerification = ref(localStorage.getItem('lastVerification') || 0);

    function setToken(tokenValue) {
        localStorage.setItem('token', tokenValue);
        // clear session-toast suppression when a new token is set (successful login)
        if (tokenValue) {
            localStorage.removeItem('session_toast_shown');
        }
        token.value = tokenValue;
    }

    function setUser(userValue) {
        localStorage.setItem('user', userValue);
        userJson.value = userValue;
    }

    function setTenant(tenantValue) {
        localStorage.setItem('tenant', tenantValue);
        tenantJson.value = tenantValue;
    }

    function getBearer() {
        return {headers: { Authorization : "Bearer "+token.value }}
    }

    function setLastVerification(now = Date.now()) {
        localStorage.setItem('lastVerification', now);
        lastVerification.value = now;
    }

    async function verifyToken() {
        const now = Date.now();
        if (!token.value) { return false }
        if ((now - lastVerification.value) < (5 * 60 * 1000)) { return true } //5 minutos
        try {
            const {data} = await http.get('/verifyToken'); // Interceptor cuida do Bearer
            const isValid = !!data?.user;
            if (isValid) { 
                setLastVerification(now);
                if (data.user) setUser(JSON.stringify(data.user));
                if (data.tenant) setTenant(JSON.stringify(data.tenant));
            }
            return isValid;
        } catch (error) {
            console.log(error?.response?.data);
            return false;
        }
    }

    function clearData() {
        // suppress session toast during explicit logout to avoid duplicates
        try { localStorage.setItem('session_toast_shown', '1'); } catch(e){}
        setToken(null);
        setUser(null);
        setTenant(null);
        setLastVerification(0);
        console.log('Dados de autenticação limpos.');
    }

    async function logout() {
        try {
            await http.post('/logout'); // Interceptor cuida do Bearer
        } catch (error) {
            console.log('Erro ao fazer logout:');
            console.log(error?.response?.data);
        } finally {
            clearData();
            router.push({name: 'login'});
        }
    }

    return {token, user, tenant, setToken, setUser, setTenant, verifyToken, getBearer, logout, clearData, setLastVerification}
})
